<template>
  <div class="app-container">
    <CrudTable entity="Role" :columns="columns" :requires-domain-id="true" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['name', 'description']
    };
  }
};
</script>

<style scoped></style>
